import { c as _c } from "react/compiler-runtime";
import { ParsedUrlQuery } from 'querystring';
import { useMemo, useState } from 'react';
import { useDidUpdateEffect } from 'shared/hooks/use-did-update-effect';
import { QueryKeysEnum } from 'shared/route-query/enum/query-keys-enum';
import { useQuery } from 'shared/route-query/hooks/use-query';
import { getSortQuery } from 'shared/route-query/utils/get-sort-query';
import { setSortFromQuery } from 'shared/route-query/utils/set-sort-from-query';
import { deepCompare } from 'shared/utils/deepCompare';
import { SortDirectionEnum } from '../../components/table/enums';
export namespace useSorter {
  export interface SortInterface<S extends string> {
    sortColumn: S | undefined;
    sortDirection: SortDirectionEnum | undefined;
  }
}
export function useSorter(isStaticUrl, options) {
  const $ = _c(23);
  const t0 = options?.sortColumn;
  const t1 = options?.sortDirection;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      sortColumn: t0,
      sortDirection: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const defaultSort = t2;
  const [sort, setSort] = useState(defaultSort);
  const getNextOrder = _temp;
  let t3;
  if ($[3] !== sort) {
    t3 = field => {
      const isSameField = sort.sortColumn === field;
      if (isSameField) {
        const newSortDirection = getNextOrder(sort.sortDirection);
        setSort(prev => ({
          ...prev,
          sortDirection: newSortDirection,
          sortColumn: newSortDirection ? field : undefined
        }));
      } else {
        setSort({
          sortColumn: field,
          sortDirection: getNextOrder(undefined)
        });
      }
    };
    $[3] = sort;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setNextSortDirection = t3;
  let t4;
  if ($[5] !== sort) {
    t4 = field_0 => sort.sortColumn === field_0 ? sort.sortDirection : undefined;
    $[5] = sort;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const getSortDirection = t4;
  const [memoizedQueryData, setMemoizedQueryData] = useState();
  let t5;
  if ($[7] !== defaultSort || $[8] !== sort) {
    t5 = () => {
      if (deepCompare(sort, defaultSort)) {
        return;
      }
      const query = {
        ...getSortQuery({
          sort,
          defaultSort
        })
      };
      setMemoizedQueryData(query);
    };
    $[7] = defaultSort;
    $[8] = sort;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== sort) {
    t6 = [sort];
    $[10] = sort;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  useDidUpdateEffect(t5, t6);
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [QueryKeysEnum.SortColumn, QueryKeysEnum.SortDirection];
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== defaultSort) {
    t8 = query_0 => {
      setSort(setSortFromQuery(query_0, defaultSort));
    };
    $[13] = defaultSort;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isStaticUrl || $[16] !== memoizedQueryData || $[17] !== t8) {
    t9 = {
      data: memoizedQueryData,
      skip: isStaticUrl,
      keys: t7,
      onChange: t8
    };
    $[15] = isStaticUrl;
    $[16] = memoizedQueryData;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  useQuery(t9);
  let t10;
  if ($[19] !== getSortDirection || $[20] !== setNextSortDirection || $[21] !== sort) {
    t10 = {
      sort,
      setSort,
      getSortDirection,
      setNextSortDirection
    };
    $[19] = getSortDirection;
    $[20] = setNextSortDirection;
    $[21] = sort;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp(currentOrder) {
  switch (currentOrder) {
    case SortDirectionEnum.Asc:
      {
        return SortDirectionEnum.Desc;
      }
    case SortDirectionEnum.Desc:
      {
        return;
      }
    default:
      {
        return SortDirectionEnum.Asc;
      }
  }
}